import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurEnBetalingen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M35 12H5v16h30z"
    />
    <path
      fill="#B3E9B1"
      d="M15.61 21.2h-1.44v-2.4h1.44c.51-2.74 2.75-4.8 5.44-4.8 1.53 0 2.92.67 3.92 1.76l-1.73 1.64c-.59-.64-1.37-1-2.2-1-1.36 0-2.56.99-3 2.4h3.32v2.4h-3.32c.44 1.41 1.64 2.4 3 2.4.82 0 1.6-.36 2.2-1l1.73 1.64c-1 1.09-2.39 1.76-3.92 1.76-2.68 0-4.92-2.06-5.44-4.8"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M8.25 28c0-1.79-1.46-3.25-3.25-3.25V28zM5 15.25c1.79 0 3.25-1.46 3.25-3.25H5zM31.75 12c0 1.79 1.46 3.25 3.25 3.25V12zM35 24.75c-1.79 0-3.25 1.46-3.25 3.25H35z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M14.17 30.03H6.12V24h1v5.03h7.05z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurEnBetalingen);

export default ForwardRef;
